import {useEffect, useLayoutEffect, useRef} from "react";
import {Top, Bottom, Button, ChoiceList, RiveLoad, RivePreload, RiveFetch} from "parts";
import {loadCss, useSurvey} from "utils";
import {useTranslation} from "react-i18next";
import {Graph, Steps, Swipe} from "../parts";
import {SurveyEnum} from "_business";

export function Survey({step, nextUrl}) {
  const
    // {t} = useTranslation('survey', {keyPrefix: 'layout'}),
    {t: t0} = useTranslation(),
    steps = t0('steps', {ns: 'survey', returnObjects: true})

  const
    topRef = useRef(null),
    namingRef = useRef(null),
    avatarRef = useRef(null),
    boobleRef = useRef(null),
    namingAnimate = useRef(true)

  const
    {
      state, // setState, g1,
      surveyList,
      survey, surveyNext,
      isNext, isNextEnable, handleNext,
      handleBack,
      handleChange,
      handleFillResults
    } = useSurvey({step, nextUrl})

  useLayoutEffect(() => loadCss('/charisma/static/css/Survey.css'), [])

  useEffect(() => {
    let count = 0

    for (const item of steps) {
      count += item.count

      if (state.index === count) {
        namingAnimate.current = true
        avatarRef.current?.classList.add('avatar-animate')
        boobleRef.current?.classList.add('booble-hidden')
        boobleRef.current?.classList.add('booble-animate')
        break
      }
    }

    if (!namingRef.current || !namingAnimate.current)
      return

    namingAnimate.current = false

    const timer = setTimeout(() => {
      avatarRef.current?.classList.remove('avatar-animate')
      boobleRef.current?.classList.remove('booble-hidden')
      boobleRef.current?.classList.remove('booble-animate')
    }, 1500)

    return () => clearTimeout(timer)
  }, [state.index])

  if (!survey) {
    console.error('survey is empty', state.index, surveyList, state.resultList);
    return
  }

  const
    answerIndex = state.resultList[state.index]?.[0],
    answer = survey.list?.[answerIndex],
    isAnswered =
      [SurveyEnum.line, SurveyEnum.swipe].includes(survey.type) && state.resultList[state.index]?.length > 0

  if (survey.calc) {
    let count = 0

    for (let i = state.index - 1; state.index - i <= 4; i--)
      count += state.resultList[i][0]

    // 0-1 = 0
    // 2-3 = 1
    // 4 = 2
    const ind = Math.min(2, Math.floor(count / 2))
    survey.name = survey.calc[ind].name
  }

  return (
    <div className={'wrap fixed' + (isNext() ? ' md' : '')}>
      <Top tref={topRef} type={survey.type} className={'survey'}>
        {
          process.env.REACT_APP_DEBUG &&
          <Button variant={'gold'} size={'sm'} onClick={handleFillResults} style={{position: 'fixed', top: 5, right: 5, width: 'auto'}}>fill</Button>
        }

        <Steps index={state.index} onBack={handleBack}/>

        {
          survey.image &&
          <img className={'d-block mw-100 block-image'} style={{aspectRatio: survey.ratio}} {...survey.imageProps} src={survey.image} alt={''}/>
        }

        {
          survey.rive && (
            survey.fetch
              ? <RiveFetch className={'block-image'} {...survey.rive}/>
              : <RiveLoad key={survey.rive.src} className={'block-image'} {...survey.rive}/>
          )
        }

        {
          survey.name &&
          <div ref={namingRef} className="naming row gap-2" style={{alignItems: 'start'}}>
            <img ref={avatarRef} width={40} height={40} alt="ava"
              src={'/charisma/static/img/survey/avatar.png'}
              className={namingAnimate.current ? 'avatar-animate' : ''}
            />
            <div
              ref={boobleRef}
              className={
                'w-100 surface pre-line rounded-2 small text-start' + (namingAnimate.current ? ' booble-hidden booble-animate' : '') +
                (isAnswered ? ' violet' : '')
              }
              style={{lineHeight: '21px', padding: '0.5rem 1rem'}}
            >
              {
                isAnswered
                  ? survey.list[state.resultList[state.index][0]].name
                  : survey.name
              }
            </div>
          </div>
        }

        {
          survey.id === 'graph' && answer &&
          <Graph answer={answer} index={answerIndex}/>
        }

        {
          survey.list && (
            survey.type === SurveyEnum.swipe
              ? !isAnswered && <Swipe onChange={handleChange}/>
              : <ChoiceList index={state.index} survey={survey} className={survey.class}
                            checkedList={state.resultList[state.index]} onChange={handleChange}/>
          )
        }
        {
          survey.type === SurveyEnum.rating &&
          <div className={'rating-info row wide notice small'} style={{marginTop: -12}}>
            <div>{survey.min}</div>
            <div>{survey.max}</div>
          </div>
        }
      </Top>

      <Bottom footer={false}>
        {
          isNext() &&
          <>
            <Button disabled={!isNextEnable()} onClick={() => handleNext()}>{survey.btn || t0('continue')}</Button>
            <p className={'mb-1'}/>
          </>
        }
      </Bottom>

      {
        surveyNext?.rive &&
        <RivePreload {...surveyNext.rive}/>
      }
    </div>
  )
}